export default "__VITE_ASSET___iH9S04u__"